module.exports = __webpack_public_path__ + "23842031398707a67a08a4018ec3ae75.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/Textual.png
// module id = 2254
// module chunks = 0